var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-tab",
      class: {
        "cw-tab-active": _vm.isActive,
      },
      attrs: {
        role: "tabpanel",
        id: _vm.id,
        "aria-labelledby": _vm.selectorId,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }